import React from "react";

import styles from "./Icon.module.scss";

const Icon = ({ className, size: fontSize, type }) => (
  <i
    className={`${styles.base} ${className ? className : ""} ${styles[type]}`}
    style={{ fontSize }}
  />
);

export default Icon;
